import moment from "moment";

/** Local day bounds → UTC ISO. Backend filters on UTC, the picker gives local midnight. */
export const getUtcDayRange = (date) => {
  const day = date || new Date();
  return {
    createdStart: moment(day).startOf("day").toISOString(),
    createdEnd: moment(day).endOf("day").toISOString(),
  };
};
